module.exports = __webpack_public_path__ + "img/HydroNext.e70aea82.png";